/** Profil pamięci: podgląd i edycja aktywnej wersji (append-only po stronie backendu). */

import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../api";
import { settingsKeys } from "./SettingsPage";

export function MemorySection() {
  const qc = useQueryClient();
  const { data, isLoading, error } = useQuery({
    queryKey: settingsKeys.memory,
    queryFn: api.memory,
  });
  const [draft, setDraft] = useState<string | null>(null);

  useEffect(() => {
    setDraft(null);
  }, [data?.version]);

  const save = useMutation({
    mutationFn: (content: string) => api.saveMemory(content),
    onSuccess: (profile) => {
      qc.setQueryData(settingsKeys.memory, profile);
      setDraft(null);
    },
  });

  const content = draft ?? data?.content ?? "";
  const dirty = draft !== null && draft !== (data?.content ?? "");

  return (
    <section className="card settings__section">
      <header className="card__head">
        <h2 className="card__title">Pamięć</h2>
        <button
          className="btn btn--primary btn--small"
          disabled={!dirty || save.isPending}
          onClick={() => save.mutate(content)}
        >
          {save.isPending ? "Zapisuję…" : "Zapisz"}
        </button>
      </header>
      <p className="muted">
        Trwałe fakty, preferencje i słownictwo — ten dokument trafia do każdego promptu.
        {data?.version ? ` Wersja ${data.version}.` : ""}
      </p>

      {isLoading && <p className="muted">Ładowanie…</p>}
      {error && <p className="error">Nie udało się pobrać profilu pamięci.</p>}
      {save.error && <p className="error">Nie udało się zapisać profilu.</p>}

      <textarea
        className="field__input settings__memory"
        rows={14}
        spellCheck={false}
        value={content}
        onChange={(e) => setDraft(e.target.value)}
        aria-label="Profil pamięci"
      />
    </section>
  );
}
